/**
* Scrolling CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      setCtaHeight();

      function setCtaHeight() {
        let scrollingColumnHeight = 0;
        if ( window.innerWidth >= 1024 ) {
          scrollingColumnHeight = $( '.scrolling-column' ).outerHeight() + 160;
        } else {
          scrollingColumnHeight = $( '.scrolling-column' ).outerHeight() + 340;
        }
        $( '.scrolling-cta' ).css( 'height', scrollingColumnHeight + 'px' );
      }

      $( window ).resize( function() {
        setCtaHeight();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-cta', COMPONENT );
} )( app );
